import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function svgProps(size) {
    return {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2.4,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": true,
        focusable: false,
    };
}
export function CheckIcon({ size = 16, className }) {
    return (_jsx("svg", { ...svgProps(size), className: className, children: _jsx("path", { d: "M4 12.5 9.5 18 20 6.5" }) }));
}
export function CrossIcon({ size = 16, className }) {
    return (_jsx("svg", { ...svgProps(size), className: className, children: _jsx("path", { d: "M6 6l12 12M18 6L6 18" }) }));
}
export function AlertIcon({ size = 16, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M12 3 1.8 20.5h20.4L12 3Z" }), _jsx("path", { d: "M12 9.5v5" }), _jsx("path", { d: "M12 17.6v.1" })] }));
}
export function InfoIcon({ size = 16, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("circle", { cx: "12", cy: "12", r: "9.2" }), _jsx("path", { d: "M12 11v5.5" }), _jsx("path", { d: "M12 7.6v.1" })] }));
}
export function PlugIcon({ size = 16, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M9 3v6M15 3v6" }), _jsx("path", { d: "M6 9h12v3a6 6 0 0 1-12 0V9Z" }), _jsx("path", { d: "M12 18v3" })] }));
}
export function EyeIcon({ size = 20, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M2 12s3.8-6.5 10-6.5S22 12 22 12s-3.8 6.5-10 6.5S2 12 2 12Z" }), _jsx("circle", { cx: "12", cy: "12", r: "2.8" })] }));
}
export function EyeOffIcon({ size = 20, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M3 3l18 18" }), _jsx("path", { d: "M10.6 6.1A10.9 10.9 0 0 1 12 5.5c6.2 0 10 6.5 10 6.5a19 19 0 0 1-3.6 4.3" }), _jsx("path", { d: "M6.4 7.9A19 19 0 0 0 2 12s3.8 6.5 10 6.5c1.4 0 2.6-.3 3.7-.7" }), _jsx("path", { d: "M9.6 9.8a2.8 2.8 0 0 0 3.9 3.9" })] }));
}
export function RerollIcon({ size = 20, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M20 5v5h-5" }), _jsx("path", { d: "M19.3 10a8 8 0 1 0 .3 4.5" })] }));
}
export function LockIcon({ size = 20, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("rect", { x: "4.5", y: "10", width: "15", height: "10.5", rx: "2.5" }), _jsx("path", { d: "M8.2 10V7.4a3.8 3.8 0 0 1 7.6 0V10" })] }));
}
export function ChevronIcon({ size = 18, className }) {
    return (_jsx("svg", { ...svgProps(size), className: className, children: _jsx("path", { d: "M9 5l7 7-7 7" }) }));
}
/**
 * The way out of a room (§22.17.8 C). Paired with the `Leave` label at wide
 * widths and standing alone as the whole control once the label sheds below 360
 * (§4.1) — so it is one glyph, fewer parts, not a swap of identity across a
 * breakpoint. A door with an arrow pointing **out toward the trailing edge**,
 * because `Leave` sits at the trailing end of row 1 and an inward arrow would
 * read as "join". Default `size = 18`: 16 disappears at 195, 20 shouts beside
 * `sm` type. No fill, no second colour, no badge (§4.2 stays `ghost`).
 */
export function ExitIcon({ size = 18, className }) {
    return (_jsxs("svg", { ...svgProps(size), className: className, children: [_jsx("path", { d: "M13.5 4H6.6A2.6 2.6 0 0 0 4 6.6v10.8A2.6 2.6 0 0 0 6.6 20h6.9" }), _jsx("path", { d: "M11 12h10" }), _jsx("path", { d: "M17.6 8.2 21.4 12l-3.8 3.8" })] }));
}
//# sourceMappingURL=Icons.js.map